export default function NomenclaturesConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('nomenclatures');
}

NomenclaturesConfiguration.$inject = ['$translatePartialLoaderProvider'];
